import {all, call, put, select, takeLatest} from 'redux-saga/effects';

import request from 'utils/request';
import {makeSelectUserToken} from 'reducers/selectors/userSelectors';

import {
  CREATE_TEAM,
  createTeamFailed,
  createTeamSuccess,
  GET_STAFF,
  GET_TEAM_MEMBERS,
  getStaffFailed,
  getStaffSuccess,
  getTeamMembersFailed,
  getTeamMembersSuccess,
  SWITCH_ORDER,
} from 'actions/teamActions';

function* createUpdateTeam(action) {
  const authToken = yield select(makeSelectUserToken());
  let url = `team`;
  const requestOptions = {
    method: 'POST',
    body: JSON.stringify(action.details),
  };
  if (action.filter) {
    url = `${url}/${action.filter}`;
  }

  try {
    const response = yield call(request, url, authToken, requestOptions);
    yield put(createTeamSuccess(action.id, response.team));
  } catch (err) {
    let error = err.message;
    if (error.indexOf('duplicate key ') > -1) {
      error = 'Team with this leader is already exists!';
    }
    yield put(
      createTeamFailed(error, action.id || action.details._id || 'new_user')
    );
  }
}

function* switchOrder(action) {
  const authToken = yield select(makeSelectUserToken());
  const url = `team/switch`;
  const requestOptions = {
    method: 'PUT',
    body: JSON.stringify(action.users),
  };

  try {
    const response = yield call(request, url, authToken, requestOptions);
  } catch (err) {}
}

function* getTeamMembers(action) {
  const authToken = yield select(makeSelectUserToken());
  let url = `team`;
  if (action.filter) {
    url += `/${action.filter}`;
    if (action.filter === 'post') {
      if (action.pageFolderId) url += `?pageFolderId=${action.pageFolderId}`;
    } else if (
      action.filter === 'company' &&
      action.pageFolderId === 'partner'
    ) {
      url += `?bothPublished=${true}`;
    }
  }

  try {
    const response = yield call(request, url, authToken, {});
    yield put(getTeamMembersSuccess(response));
  } catch (err) {
    yield put(getTeamMembersFailed(err.message));
  }
}

function* getStaff() {
  const authToken = yield select(makeSelectUserToken());
  const url = 'team/staff';
  try {
    const response = yield call(request, url, authToken, {});
    yield put(getStaffSuccess(response));
  } catch (err) {
    yield put(getStaffFailed(err.message));
  }
}

export default function* teamSaga() {
  yield all([
    takeLatest(CREATE_TEAM, createUpdateTeam),
    takeLatest(GET_TEAM_MEMBERS, getTeamMembers),
    takeLatest(GET_STAFF, getStaff),
    takeLatest(SWITCH_ORDER, switchOrder),
  ]);
}
